/* eslint-disable no-unused-vars */
import 'reflect-metadata';
// -----------------------------------------------------------------------------
const kConditionTypeMetadataKey = Symbol('ConditionType');

// -----------------------------------------------------------------------------
export enum ConditionType {
  Global,
  Promotion,
}

// -----------------------------------------------------------------------------
// @conditionType
export const conditionType = (type: ConditionType) => {
  return (target: any) => {
    Reflect.defineMetadata(kConditionTypeMetadataKey, type, target.prototype);
    return target;
  };
};

// -----------------------------------------------------------------------------
export const getConditionType = (target: any): ConditionType => {
  return Reflect.getMetadata(kConditionTypeMetadataKey, target);
};
